<template>
  <div class="t-overflow-x-auto">
    <div
      class="t-align-middle t-inline-block t-min-w-full tracker-info t-overflow-y-auto t-mt-2"
      role="table"
    >
      <div class="t-w-70 t-p-9">
          <p v-if="isLoaded && trackers > 0">You have {{trackers}} trackers at your locations
            <a
              type="button"
              href="/send-freight/tracker/business/dashboard?tab=OnSiteTrackersTab"
              class="view-trackers t-rounded-md t-px-3 t-py-1 t-bg-dodger-blue t-text-sm t-font-medium t-text-white hover:t-bg-blue-500"
            >
                View
            </a>
          </p>
          <p v-else-if="isLoaded && trackers === 0">
            You don't have any trackers at your locations
          </p>
          <p v-else-if="!isLoaded && errorMsg">
            {{errorMsg}}
          </p>
          <p v-else>
            Loading...
          </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   name: 'TrackerInfo',
   props: ['trackers', 'isLoaded', 'errorMsg']
}

</script>

<style scoped>
.tracker-info {
  min-height: 2rem;
  max-height: 6rem;
}

i.anticon {
  height: 1rem;
}

.view-trackers {
  text-decoration: none;
  color: white;
}
</style>
